import { t } from 'i18next'
import React from 'react'
import ModalV2 from 'components/ModalV2/ModalV2'
import ModalV2Buttons from 'components/ModalV2Buttons/ModalV2Buttons'
import { DocumentsModalBody } from '../../modals/documentsModalV2Shared'

const ModalForGoBack = ({goBack, goBackModalStatus, toggleGoBackModalStatus}) => {
	return (
		<ModalV2
			open={goBackModalStatus}
			onClose={goBack}
			width={480}
			title={t("vatReturns.warning")}
			content={
				<DocumentsModalBody>
					<p>Do you really want to go back? All data will be lost.</p>
				</DocumentsModalBody>
			}
			footer={
				<ModalV2Buttons
					onCancel={goBack}
					onConfirm={toggleGoBackModalStatus}
					cancelText="Yes"
					confirmText="No"
					variant="primary"
				/>
			}
		/>
	)
}

export default ModalForGoBack
